define([
    './CampaignSegmentationDirective',
    'edge/platform/campaign/module'
], (CampaignSegmentationDirective) => {
    return angular.module('edge.platform.segmentation.campaign', [
        'edge.platform.campaign'
    ])
        .directive('gwCampaignSegmentation', CampaignSegmentationDirective);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/campaign/module.js